<template>
  <div class="text-area-field">
    <textarea
      id="textarea1"
      class="materialize-textarea"
      placeholder="Enter details"
      v-model="fieldValue"
      :disabled="dataDisable"
    ></textarea>
  </div>
</template>
<script>
export default {
  name: "TextAreaField",
  props: {
    dataValue: {
      type: [String, Number],
      default: () => "",
    },

    dataDisable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fieldValue: this.dataValue,
    };
  },
  watch: {
    fieldValue(val) {
      this.$emit("updateValue", val);
    },

    dataDisable(nV) {
      console.log(nV);
    },
  },

  mounted() {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.option-selector {
  border-radius: 10px;
  h5 {
    text-align: center;
  }
  .img-wrapper {
    height: 60px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .img-wrapper-survey {
    display: flex;
    justify-content: center;
    img {
      margin: 0 auto;
      width: auto;
      height: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    max-width: 90% !important;
    width: 90%;
  }
}
</style>
